import { h1 } from '@paypalcorp/pp-react'
import React from 'react'

export default class DummyTempComponent extends React.Component {
  render() {
    return <h1>Template Component to be replaced with real screens.</h1>
  }
}
